export enum ModalAction {
  GlobalApprove = 'global_approve',
  Reject = 'reject',
  GlobalReject = 'global_reject',
  RestartApprovalFlow = 'restart_approval_flow',
  CreatePayrollSupplement = 'create_payroll_supplement',
  RemoveRayrollSupplement = 'remove_payroll_supplement',
  AddToGroup = 'add_to_group',
  AddToPayment = 'add_to_payment',
  RemoveFromGroup = 'remove_from_group',
  Delete = 'delete',
}
